import React, { Component } from "react";
import { SelectOptions } from "components";
import { css } from "react-emotion";
import { Grid, GridItem } from "appStyles";
import Switch from "@material-ui/core/Switch";
import CancelIcon from "@material-ui/icons/Cancel";

const timeoptions = [
  { value: "12:00 AM", label: "12:00 AM" },
  { value: "12:15 AM", label: "12:15 AM" },
  { value: "12:30 AM", label: "12:30 AM" },
  { value: "12:45 AM", label: "12:45 AM" },
  { value: "01:00 AM", label: "01:00 AM" },
  { value: "01:15 AM", label: "01:15 AM" },
  { value: "01:30 AM", label: "01:30 AM" },
  { value: "01:45 AM", label: "01:45 AM" },
  { value: "02:00 AM", label: "02:00 AM" },
  { value: "02:15 AM", label: "02:15 AM" },
  { value: "02:30 AM", label: "02:30 AM" },
  { value: "02:45 AM", label: "02:45 AM" },
  { value: "03:00 AM", label: "03:00 AM" },
  { value: "03:15 AM", label: "03:15 AM" },
  { value: "03:30 AM", label: "03:30 AM" },
  { value: "03:45 AM", label: "03:45 AM" },
  { value: "04:00 AM", label: "04:00 AM" },
  { value: "04:15 AM", label: "04:15 AM" },
  { value: "04:30 AM", label: "04:30 AM" },
  { value: "04:45 AM", label: "04:45 AM" },
  { value: "05:00 AM", label: "05:00 AM" },
  { value: "05:15 AM", label: "05:15 AM" },
  { value: "05:30 AM", label: "05:30 AM" },
  { value: "05:45 AM", label: "05:45 AM" },
  { value: "06:00 AM", label: "06:00 AM" },
  { value: "06:15 AM", label: "06:15 AM" },
  { value: "06:30 AM", label: "06:30 AM" },
  { value: "06:45 AM", label: "06:45 AM" },
  { value: "07:00 AM", label: "07:00 AM" },
  { value: "07:15 AM", label: "07:15 AM" },
  { value: "07:30 AM", label: "07:30 AM" },
  { value: "07:45 AM", label: "07:45 AM" },
  { value: "08:00 AM", label: "08:00 AM" },
  { value: "08:15 AM", label: "08:15 AM" },
  { value: "08:30 AM", label: "08:30 AM" },
  { value: "08:45 AM", label: "08:45 AM" },
  { value: "09:00 AM", label: "09:00 AM" },
  { value: "09:15 AM", label: "09:15 AM" },
  { value: "09:30 AM", label: "09:30 AM" },
  { value: "09:45 AM", label: "09:45 AM" },
  { value: "10:00 AM", label: "10:00 AM" },
  { value: "10:15 AM", label: "10:15 AM" },
  { value: "10:30 AM", label: "10:30 AM" },
  { value: "10:45 AM", label: "10:45 AM" },
  { value: "11:00 AM", label: "11:00 AM" },
  { value: "11:15 AM", label: "11:15 AM" },
  { value: "11:30 AM", label: "11:30 AM" },
  { value: "11:45 AM", label: "11:45 AM" },
  { value: "12:00 PM", label: "12:00 PM" },
  { value: "12:15 PM", label: "12:15 PM" },
  { value: "12:30 PM", label: "12:30 PM" },
  { value: "12:45 PM", label: "12:45 PM" },
  { value: "01:00 PM", label: "01:00 PM" },
  { value: "01:15 PM", label: "01:15 PM" },
  { value: "01:30 PM", label: "01:30 PM" },
  { value: "01:45 PM", label: "01:45 PM" },
  { value: "02:00 PM", label: "02:00 PM" },
  { value: "02:15 PM", label: "02:15 PM" },
  { value: "02:30 PM", label: "02:30 PM" },
  { value: "02:45 PM", label: "02:45 PM" },
  { value: "03:00 PM", label: "03:00 PM" },
  { value: "03:15 PM", label: "03:15 PM" },
  { value: "03:30 PM", label: "03:30 PM" },
  { value: "03:45 PM", label: "03:45 PM" },
  { value: "04:00 PM", label: "04:00 PM" },
  { value: "04:15 PM", label: "04:15 PM" },
  { value: "04:30 PM", label: "04:30 PM" },
  { value: "04:45 PM", label: "04:45 PM" },
  { value: "05:00 PM", label: "05:00 PM" },
  { value: "05:15 PM", label: "05:15 PM" },
  { value: "05:30 PM", label: "05:30 PM" },
  { value: "05:45 PM", label: "05:45 PM" },
  { value: "06:00 PM", label: "06:00 PM" },
  { value: "06:15 PM", label: "06:15 PM" },
  { value: "06:30 PM", label: "06:30 PM" },
  { value: "06:45 PM", label: "06:45 PM" },
  { value: "07:00 PM", label: "07:00 PM" },
  { value: "07:15 PM", label: "07:15 PM" },
  { value: "07:30 PM", label: "07:30 PM" },
  { value: "07:45 PM", label: "07:45 PM" },
  { value: "08:00 PM", label: "08:00 PM" },
  { value: "08:15 PM", label: "08:15 PM" },
  { value: "08:30 PM", label: "08:30 PM" },
  { value: "08:45 PM", label: "08:45 PM" },
  { value: "09:00 PM", label: "09:00 PM" },
  { value: "09:15 PM", label: "09:15 PM" },
  { value: "09:30 PM", label: "09:30 PM" },
  { value: "09:45 PM", label: "09:45 PM" },
  { value: "10:00 PM", label: "10:00 PM" },
  { value: "10:15 PM", label: "10:15 PM" },
  { value: "10:30 PM", label: "10:30 PM" },
  { value: "10:45 PM", label: "10:45 PM" },
  { value: "11:00 PM", label: "11:00 PM" },
  { value: "11:15 PM", label: "11:15 PM" },
  { value: "11:30 PM", label: "11:30 PM" },
  { value: "11:45 PM", label: "11:45 PM" },
];

const selector = css`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
`;

const selectors = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: auto;
  margin-bottom: 0.5em;
`;

const checkBoxStyle = css`
  margin: 1.3em 1em auto 1em;
  cursor: pointer;
`;

const constructString = (days) => {
  let hourString = "";
  Object.keys(days).forEach((day) => {
    const { hours, open } = days[day];

    // if it's closed state closed
    if (open === true) {
      hourString += `${day}: ${hours.join(",")}|`;
    } else {
      hourString += `${day}: Closed|`;
    }
  });
  return hourString;
};
export default class OpenHoursPicker extends Component {
  state = {
    Monday: {
      hours: ["10:00 AM - 10:00 PM", "10:00 AM - 10:00 PM"],
      open: false,
    },
    Tuesday: {
      hours: ["10:00 AM - 10:00 PM"],
      open: false,
    },
    Wednesday: {
      hours: ["10:00 AM - 10:00 PM"],
      open: false,
    },
    Thursday: {
      hours: ["10:00 AM - 10:00 PM"],
      open: false,
    },
    Friday: {
      hours: ["10:00 AM - 10:00 PM"],
      open: false,
    },
    Saturday: {
      hours: ["10:00 AM - 10:00 PM"],
      open: false,
    },
    Sunday: {
      hours: ["10:00 AM - 10:00 PM"],
      open: false,
    },
  };

  componentDidMount() {
    if (this.props.hours) {
      this.props.hours.split("|").forEach((hour) => {
        if (hour) {
          const [day, times] = hour.split(": ");
          this.setState({
            [day]: {
              hours:
                times === "Closed" ? ["12:00 AM - 12:00 AM"] : times.split(","),
              open: times === "Closed" ? false : true,
            },
          });
        }
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.hours !== prevProps.hours) {
      this.props.hours.split("|").forEach((hour) => {
        if (hour) {
          const [day, times] = hour.split(": ");
          this.setState({
            [day]: {
              hours:
                times === "Closed" ? ["12:00 AM - 12:00 AM"] : times.split(","),
              open: times === "Closed" ? false : true,
            },
          });
        }
      });
    }
  }

  updateGlobal = () => {
    let hours = constructString(this.state);
    this.props.updateHours(hours);
  };

  update = (type, key, hourIdx) => (value) => {
    let times = this.state[key].hours;
    const open = this.state[key].open;
    let time = times[hourIdx].split(" - ");
    time[type] = value;
    const newTime = time.join(" - ");
    times[hourIdx] = newTime;

    this.setState(
      {
        [key]: {
          hours: times,
          open,
        },
      },
      () => {
        let hours = constructString(this.state);
        this.props.updateHours(hours);
      }
    );
  };

  getTime = (type, hours) => {
    return hours.split(" - ")[type];
  };

  toggleDay = (day) => {
    const targetDay = this.state[day];
    targetDay.open = !targetDay.open;
    this.setState(
      {
        [day]: targetDay,
      },
      this.updateGlobal
    );
  };

  addTime = (day) => {
    const { hours, open } = this.state[day];
    hours.push("10:00 AM - 10:00 PM");

    this.setState(
      {
        [day]: {
          hours,
          open,
        },
      },
      this.updateGlobal
    );
  };

  removeTime = (day, idx) => {
    const { hours, open } = this.state[day];
    hours.splice(idx);
    this.setState(
      {
        [day]: {
          hours,
          open,
        },
      },
      this.updateGlobal
    );
  };

  render() {
    const days = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];

    return (
      <div>
        <br />
        Open Hours
        <div
          style={{
            marginBottom: "30px",
          }}
        >
          {days.map((day, idx) => {
            const { open, hours } = this.state[day];

            return (
              <div
                key={idx}
                style={{
                  display: "flex",
                  marginBottom: "30px",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    width: "140px",
                  }}
                >
                  <Switch
                    checked={open}
                    onChange={() => this.toggleDay(day)}
                    color="primary"
                    name="isLive"
                    inputProps={{ "aria-label": "primary checkbox" }}
                  />
                  <span
                    style={{
                      width: "5.5em",
                    }}
                  >
                    {day}:{" "}
                  </span>
                  <br />
                  <a
                    onClick={() => this.addTime(day)}
                    style={{
                      fontSize: "11px",
                      backgroundColor: "none",
                      textDecoration: "underline",
                      cursor: "pointer",
                      position: "absolute",
                      bottom: "-15px",
                    }}
                  >
                    Add Additional Hours
                  </a>
                </div>
                <div>
                  {hours &&
                    hours.map((hour, hourIdx) => {
                      return (
                        <div
                          key={hourIdx}
                          style={{
                            // marginLeft: "360px",
                            display: "flex",
                            marginTop: "10px",
                          }}
                        >
                          <SelectOptions
                            isDisabled={!open}
                            width="8em"
                            value={this.getTime(0, hour)}
                            options={timeoptions}
                            setValue={this.update(0, day, hourIdx)}
                            marginRight="20px"
                          />
                          <SelectOptions
                            isDisabled={!open}
                            width="8em"
                            value={this.getTime(1, hour)}
                            options={timeoptions}
                            setValue={this.update(1, day, hourIdx)}
                            marginRight="20px"
                          />
                          <a
                            onClick={() => this.removeTime(day, hourIdx)}
                            style={{
                              fontSize: "11px",
                              backgroundColor: "none",
                              color: "red",
                              cursor: "pointer",
                              marginTop: "10px",
                              // marginLeft: "10px"
                              // position: "absolute",
                              // bottom: "-10px"
                            }}
                          >
                            <CancelIcon></CancelIcon>
                          </a>
                        </div>
                      );
                    })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
